(function ($) {

    var triggers = ['#reservation-button', '.commander-reserve-mobile'];

    for (var i = 0; i < triggers.length; i++) {
        $(triggers[i]).click(function (e) {
            e.preventDefault();
            $('#reservation-modal').modal();
        });
    }

    // Vue-Touch
    !function(){function e(e){return e.charAt(0).toUpperCase()+e.slice(1)}function t(e){var t=e.direction;if("string"==typeof t){var i="DIRECTION_"+t.toUpperCase();o.indexOf(t)>-1&&r.hasOwnProperty(i)?e.direction=r[i]:console.warn("[vue-touch] invalid direction: "+t)}}var i={},r="function"==typeof require?require("hammerjs"):window.Hammer,n=["tap","pan","pinch","press","rotate","swipe"],o=["up","down","left","right","horizontal","vertical","all"],a={};if(!r)throw new Error("[vue-touch] cannot locate Hammer.js.");i.config={},i.install=function(o){o.directive("touch",{isFn:!0,acceptStatement:!0,priority:o.directive("on").priority,bind:function(){this.el.hammer||(this.el.hammer=new r.Manager(this.el));var o=this.mc=this.el.hammer,s=this.arg;s||console.warn("[vue-touch] event type argument is required.");var h,c;if(a[s]){var u=a[s];h=u.type,c=new(r[e(h)])(u),c.recognizeWith(o.recognizers),o.add(c)}else{for(var d=0;d<n.length;d++)if(0===s.indexOf(n[d])){h=n[d];break}if(!h)return void console.warn("[vue-touch] invalid event type: "+s);c=o.get(h),c||(c=new(r[e(h)]),c.recognizeWith(o.recognizers),o.add(c));var f=i.config[h];f&&(t(f),c.set(f));var l=this.el.hammerOptions&&this.el.hammerOptions[h];l&&(t(l),c.set(l))}this.recognizer=c},update:function(e){var t=this.mc,i=this.arg;this.handler&&t.off(i,this.handler),"function"!=typeof e?console.warn("[vue-touch] invalid handler function for v-touch: "+this.arg+'="'+this.descriptor.raw):t.on(i,this.handler=e)},unbind:function(){this.mc.off(this.arg,this.handler),Object.keys(this.mc.handlers).length||(this.mc.destroy(),this.el.hammer=null)}}),o.directive("touch-options",{priority:o.directive("on").priority+1,update:function(e){var t=this.el.hammerOptions||(this.el.hammerOptions={});this.arg?t[this.arg]=e:console.warn("[vue-touch] recognizer type argument for v-touch-options is required.")}})},i.registerCustomEvent=function(e,t){t.event=e,a[e]=t},"object"==typeof exports?module.exports=i:"function"==typeof define&&define.amd?define([],function(){return i}):window.Vue&&(window.VueTouch=i,Vue.use(i))}();

    var reservationForm = new Vue({
        el: '#reservation-form',
        ready: function () {
            this.fetchOpenHours();
            this.closedDates = $('#closedDates').val();
        },
        data: {
            closedDates: '',
            event: '',
            step: 1,
            activeSteps: [],
            persons: 0,
            date: new Date,
            date_selected: false,
            hour_selected: false,
            email: '',
            name: '',
            phone: '',
            extra: '',
            sent: false,
            subscribe: true,
            processing: false,
            today: new Date,
            dailyHours: {},
            inputErrors: {
                email: '',
                name: '',
                phone: '',
            },
            week: ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'],
            calendar: {
                year: (new Date).getFullYear(),
                month: (new Date).getMonth()
            }
        },
        computed: {
            /**
             * First day of month weekday 1-Monday thru 7-Sunday.
             * @return {int}
             */
            firstOfMonth: function () {
                return (new Date(this.calendar.year, this.calendar.month, 1)).getDay() || 7;
            },
            /**
             * Number of days in currently viewed month.
             * @return {int}
             */
            daysInMonth: function () {
                return (new Date(this.calendar.year, this.calendar.month + 1, 0)).getDate();
            },
            /**
             * Validation errors messages.
             * @return {Object}
             */
            errors: function () {
                return {
                    persons:  (this.persons < 1 || this.persons > 40) ? 'Choisissez le nombre de personnes (1-40)' : '',
                    hour: (!this.hour_selected) ? 'Choisissez heure' : ''
                };
            },
            /**
             * MySQL timestamp format of the reservation datetime.
             * @return {String}
             */
            datetime: function () {
                var dt = this.date;
                var date = [];
                var time = [];

                date.push(dt.getFullYear(), ('0' + (dt.getMonth() + 1)).slice(-2), ('0' + dt.getDate()).slice(-2));
                time.push(dt.getHours(), ('0' + dt.getMinutes()).slice(-2), ('0' + dt.getSeconds()).slice(-2));

                return date.join('-') + ' ' + time.join(':');
            },
            /**
             * Reservation date in short format shown in the header.
             * @return {String}
             */
            shortDate: function () {
                var months = [
                    'janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet',
                    'août', 'septembre', 'octobre', 'novembre', 'décembre'
                ];
                return [this.date.getDate(), months[this.date.getMonth()]].join(' ');
            },
            /**
             * Reservation date in long format shown in the summary.
             * @return {String}
             */
            longDate: function () {
                var days = [
                    'dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi',
                ];

                var month_to_display = 1 + this.date.getMonth();
                if (month_to_display < 10) {
                    month_to_display = '0' + month_to_display;
                }
                return days[this.date.getDay()] + ' ' + this.date.getDate() + '/' + month_to_display + '/' + this.date.getFullYear();
            },
            /**
             * Reservation time formatted as HHhMM
             * @type {Object}
             */
            hour: {
                cache: false,
                get: function () {
                    return [this.date.getHours(), ('0' + this.date.getMinutes()).substr(-2)].join('h');
                },
                set: function (val) {
                    if (matches = val.match(/\d\d(:|h)\d\d/)) {
                        var hour = val.split(matches[1])[0];
                        var minutes = val.split(matches[1])[1] || 0;
                        var d = this.date;
                        this.date = new Date(d.getFullYear(), d.getMonth(), d.getDate(), hour, minutes);
                        this.hour_selected = true;
                    }
                }
            },
            /**
             * Reservation date in normalized format.
             * @type {Object}
             */
            datestring: {
                cache: false,
                get: function () {
                    return this.date.toISOString().substr(0, 10);
                },
                set: function (val) {
                    if (val.match(/\d\d\d\d-\d\d-\d\d/)) {
                        var date = val.split('-');
                        this.date = new Date(date[0], date[1] - 1, date[2], this.date.getHours(), this.date.getMinutes());
                    }
                }
            }
        },
        filters: {
            formatHours: function (hours) {
                return hours.map(function (hour) {
                    return hour.replace(':', 'h');
                });
            }
        },
        methods: {
            fetchOpenHours: function () {
                form = this;
                $.get('/restaurant/open-days').done(function (response) {
                    form.dailyHours = response;
                });
            },
            openHours: function (day) {
                day = day || this.date.getDay();
                var dayName = this.week[day];
                return this.dailyHours[dayName];
            },
            isOpen: function (day) {
                var dayName = this.week[day];
                var hours = this.dailyHours[dayName];
                return hours.lunch.length || hours.dinner.length;
            },
            isSelectableDate: function (day) {
                var today = this.today.getDate();
                var thisMonth = this.today.getMonth();

                var openHours = this.openHours();
                var lastHourLunch = openHours.lunch.length ? openHours.lunch[openHours.lunch.length - 1].split(':') : [100, 100];
                var lastHourDinner = openHours.dinner.length > 0 ? openHours.dinner[openHours.dinner.length - 1].split(':') : [100, 100];
                var hour = this.today.getHours();
                var minute = this.today.getMinutes();

                var hourIsPossible;

                if(hour >= lastHourLunch[0]) {
                    if ((lastHourLunch[1] - minute ) > 5) {
                        hourIsPossible = true;
                    } else {
                        hourIsPossible = false;
                    }
                } else if(hour >= lastHourDinner[0]) {
                    if ((lastHourDinner[1] - minute ) > 5) {
                        hourIsPossible = true;
                    } else {
                        hourIsPossible = false;
                    }
                } else {
                    hourIsPossible = true;
                }

                return this.calendar.month == thisMonth && day == today && hourIsPossible
                    || this.calendar.month == thisMonth && day > today
                    || this.calendar.month > thisMonth && this.calendar.month < thisMonth + 12
                    || this.calendar.month == thisMonth + 12 && day <= today
            },
            isAvailableHours: function () {
                var openHours = this.openHours();
                var lastHourLunch = openHours.lunch.length ? openHours.lunch[openHours.lunch.length - 1].split(':') : [100, 100];
                var lastHourDinner = openHours.dinner.length > 0 ? openHours.dinner[openHours.dinner.length - 1].split(':') : [100, 100];
                var hour = this.today.getHours();
                var minute = this.today.getMinutes();

                if ((hour >= lastHourLunch[0] && (lastHourLunch[1] - minute ) > 5) || (hour >= lastHourDinner[0] && (lastHourDinner[1] - minute) > 5 )) {
                    return true;
                }

                return false;
            },
            isCurrentMonth: function (day) {
                return day > 0 && day <= this.daysInMonth;
            },
            isToday: function (day) {
                var date = new Date(this.calendar.year, this.calendar.month, day);

                return this.today.toDateString() == date.toDateString();
            },
            addDays: function addDays(days) {
                var result = new Date();
                result.setDate(result.getDate() + days);

                return result;
            },
            isSelectedDate: function (day) {
                var date = new Date(this.calendar.year, this.calendar.month, day);

                return this.date.toDateString() == date.toDateString();
            },
            pickDay: function (day) {
                d = this.date;
                this.date = new Date(d.getFullYear(), this.calendar.month, day, d.getHours(), d.getMinutes());
                this.date_selected = true;
                this.step++;
                this.activateStep(this.step - 1);
            },
            activateStep: function (step) {
                if ($.inArray(step, this.activeSteps) === -1) {
                    this.activeSteps.push(step);
                }
            },
            /**
             * Close the modal and reset reservation form data.
             * @return {void}
             */
            close: function () {
                this.$data = {
                    step: 1,
                    persons: 0,
                    date: new Date,
                    date_selected: false,
                    hour_selected: false,
                    email: '',
                    name: '',
                    phone: '',
                    extra: '',
                    sent: false,
                    subscribe:true,
                    processing: false,
                    today: new Date,
                    dailyHours: {},
                    week: ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'],
                    calendar: {
                        year: (new Date).getFullYear(),
                        month: (new Date).getMonth()
                    }
                };
                $('#reservation-modal').modal('hide');
            },
            /**
             * Submit the form via AJAX.
             * @return {void}
             */
            submit: function () {
                if (this.sent || !this.validate(4)) {
                    return;
                }

                this.processing = true;

                var me = this;
                var form = this.$el;
                var $form = $(form);
                $.ajax({
                    url: $form.attr('action'),
                    type: 'POST',
                    data: new FormData(form),
                    processData: false,
                    contentType: false,
                    mimeType: "multipart/form-data",
                    success: function () {
                        me.sent = true;
                        me.processing = false;
                    },
                    error: function (response) {
                        if (response.status == 422) {
                            var errors = JSON.parse(response.responseText);
                            me.errors = errors;
                            me.processing = false;
                        }
                    }
                });
            },
            /**
             * Go to given step in the form.
             * @param  {int} step
             * @return {void}
             */
            goTo: function (step) {
                if (this.sent) {
                    return;
                }

                if (this.basicStepGuard(step)) {
                    return;
                }

                if (this.nextStepGuard(step)) {
                    return;
                }

                this.step = step;
            },
            basicStepGuard: function (step) {
                return step > 4 && step < 1 && (this.step < step || ! this.validate(this.step));
            },
            nextStepGuard: function (step) {
                var lastActive = this.activeSteps[this.activeSteps.length -1];

                return typeof lastActive === 'undefined' || step - lastActive > 1;
            },
            /**
             * Validate form at given step.
             * @param  {int} step
             * @return {bool}
             */
            validate: function (step) {
                var valid = true;
                if (step == 4) {
                    valid = valid && !this.errors.name && !this.errors.email && !this.errors.phone;
                }
                if (step > 2) {
                    valid = valid && !this.errors.hour;
                }
                if (step > 1) {
                    valid = valid && !this.errors.date;
                }
                valid = valid && !this.errors.persons;
                return valid;
            },
            validateInput: function (fieldName) {
                switch (fieldName) {
                    case 'phone':
                        this.inputErrors.phone = (!this.phone) ? 'Ce champ est obligatoire'
                            : (this.phone.length < 10) ? 'Le numéro de téléphone est invalide' : '';
                        break;

                    case 'name':
                        this.inputErrors.name = (!this.name) ? 'Ce champ est obligatoire' : '';
                        break;
                    case 'email':
                        this.inputErrors.email = (!this.email) ? 'Ce champ est obligatoire'
                        : (!this.email.match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/)) ? "L'email est invalide" : '';
                        break;
                }
            },
            /**
             * Get appropriate CSS class for given step.
             * @param  {int} step
             * @return {String}
             */
            stepClass: function (step) {
                if (step == this.step) {
                    return 'current';
                }

                if (step < this.step) {
                    return 'filled clickable';
                }
            },
            isBetweenDates: function(day, month) {
                month = month +1;
                year = new Date().getFullYear();

                if (month > 12) {
                    year = year+1;
                    month = month - 12;
                }

                if (month < 10) {
                    month = '0' + month;
                }

                if (day < 10) {
                    day = '0' + day;
                }                

                var date = day+'-'+month+'-'+year;
                var arr = $('#closedDates').val();
                
                return (arr.indexOf(date) != -1);
            }
        }
    });
})(jQuery);
